import { mainSiteUrl } from '@/mocks/categories';

export default function CouponSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
              Save Money
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
              Basetao Coupons &amp; Discount Codes
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              Discover how to reduce your Basetao shopping costs with verified coupons, seasonal promotions, and smart saving strategies
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {
                icon: 'ri-coupon-line',
                title: 'Where to Find Coupons',
                desc: 'Basetao occasionally releases promotional codes through their official website, email newsletters, and social media channels. Check during major shopping festivals like 11.11, Black Friday, and Chinese New Year for the best deals on service fees and shipping.',
              },
              {
                icon: 'ri-percent-line',
                title: 'How Discounts Apply',
                desc: 'Discount codes typically apply to service fees, shipping costs, or coupon-based savings on specific order thresholds. Some promotions offer percentage discounts while others provide fixed-amount reductions — understanding which type you have helps maximize savings.',
              },
              {
                icon: 'ri-lightbulb-line',
                title: 'Smart Saving Tips',
                desc: 'Beyond coupons, you can save by consolidating shipments, choosing economy lines for non-urgent orders, removing excess packaging, and timing your shipments during off-peak seasons when carrier rates are naturally lower.',
              },
            ].map((item) => (
              <div key={item.title} className="bg-background-50 rounded-lg border border-background-200/60 p-6 hover:border-primary-300 transition-all duration-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="font-semibold text-foreground-900 mb-2 text-base">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Check Latest Deals <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}